export const callsData = [
  {
    key:"1",
    Name: "Aaryian Jose",
    Image: "user-01.jpg",
    Total_Incoming_Call: "80",
    Total_Outgoing_Call: "100",
    Total_Missed_Call: "30",
  },
  {
    key:"2",
    Name: "Sarika Jain",
    Image: "user-02.jpg",
    Total_Incoming_Call: "120",
    Total_Outgoing_Call: "120",
    Total_Missed_Call: "120",
  },
  {
    key:"3",
    Name: "Clyde Smith",
    Image: "user-03.jpg",
    Total_Incoming_Call: "200",
    Total_Outgoing_Call: "200",
    Total_Missed_Call: "200",
  },
  {
    key:"4",
    Name: "Carla Jenkins",
    Image: "user-04.jpg",
    Total_Incoming_Call: "250",
    Total_Outgoing_Call: "250",
    Total_Missed_Call: "250",
  },
  {
    key:"5",
    Name: "Federico Wells",
    Image: "user-05.jpg",
    Total_Incoming_Call: "300",
    Total_Outgoing_Call: "300",
    Total_Missed_Call: "300",
  },
  {
    key:"6",
    Name: "Edward Lietz",
    Image: "user-06.jpg",
    Total_Incoming_Call: "180",
    Total_Outgoing_Call: "180",
    Total_Missed_Call: "180",
  },
  {
    key:"7",
    Name: "Sharon Ford",
    Image: "user-07.jpg",
    Total_Incoming_Call: "200",
    Total_Outgoing_Call: "200",
    Total_Missed_Call: "200",
  },
  {
    key:"8",
    Name: "Thomas Rethman",
    Image: "user-08.jpg",
    Total_Incoming_Call: "320",
    Total_Outgoing_Call: "320",
    Total_Missed_Call: "320",
  },
  {
    key:"9",
    Name: "Wilbur Martinez",
    Image: "user-09.jpg",
    Total_Incoming_Call: "400",
    Total_Outgoing_Call: "400",
    Total_Missed_Call: "400",
  },
  {
    key:"10",
    Name: "Danielle Baker",
    Image: "user-10.jpg",
    Total_Incoming_Call: "210",
    Total_Outgoing_Call: "210",
    Total_Missed_Call: "210",
  },
];